import { DevicePickerDropdownProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/DevicePickerDropdown';
import { DevicePickerImageProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/DevicePickerImage';
import DevicePanel, { DevicePanelProps } from '@ubnt/link-core-ui/components/BottomPanel/layout/DevicePanel';
import { InfoIndicatorProps } from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import { type IconProps } from '@ubnt/icons';
import React, { memo } from 'react';

import { WifiStandardIconProps } from 'modules/bottomPanel/components/elements/WifiStandardIcon';
import { OutdoorSwitchProps } from 'modules/bottomPanel/components/elements/OutdoorSwitch';
import { MountSwitchProps } from 'modules/bottomPanel/components/elements/MountSwitch';

import COLORS from 'styles/colors.module.scss';
import classes from './DevicePanel.module.scss';

export interface ClientDevicePanelProps extends DevicePanelProps {
  AddClientButton: React.ElementType<Partial<IconProps>>;
  ChangeAntennaButton: React.ElementType;
  DevicePickerDropdown: React.ElementType<Partial<DevicePickerDropdownProps>>;
  DevicePickerImage: React.ElementType<Partial<DevicePickerImageProps>>;
  InfoIcon: React.ElementType<Partial<InfoIndicatorProps>>;
  WifiStandardIcon: React.ElementType<Partial<WifiStandardIconProps>>;
  OutdoorSwitch: React.ElementType<Partial<OutdoorSwitchProps>>;
  MountSwitch: React.ElementType<Partial<MountSwitchProps>>;
}

const ClientDevicePanel = (props: ClientDevicePanelProps) => {
  const {
    AddClientButton,
    ChangeAntennaButton,
    DevicePickerDropdown,
    DevicePickerImage,
    InfoIcon,
    WifiStandardIcon,
    OutdoorSwitch,
    MountSwitch,
    ...rest
  } = props;

  return (
    <DevicePanel
      className={classes.WifiDevicePanel}
      image={<DevicePickerImage popoverAlign="leftCenter" />}
      imageFooter={
        <div className={classes.imageFooterContent}>
          <DevicePickerDropdown
            popoverAlign="leftCenter"
            classNamePopoverWrap={classes.popoverWrap}
            classNameDevicePickerList={classes.devicePickerList}
            classNameDevicePicker={classes.devicePicker}
            classNamePopoverCard={classes.popoverCard}
          />
          <AddClientButton className={classes.iconTooltip} color={COLORS.neutral08} size="original" actionable />
        </div>
      }
      imageContainerClassName={classes.imageContainer}
      imagePanelClassName={classes.deviceImagePanel}
      mainContentClassName={classes.mainContent}
      inputsClassName={classes.devicePanelInputs}
      {...rest}
    >
      <WifiStandardIcon className={classes.iconPlacement} />
      <InfoIcon className={classes.infoPlacement} />
      <div className={classes.buttonGroup}>
        <OutdoorSwitch />
        <MountSwitch />
        <ChangeAntennaButton />
      </div>
    </DevicePanel>
  );
};

const MemoizedClientDevicePanel = memo(ClientDevicePanel);

export default MemoizedClientDevicePanel;
